// extracted by mini-css-extract-plugin
module.exports = {"errorContainer":"ClientsTable-module__errorContainer--1lEL3"};